/* ============================================================
   ROSELASH ADVANCED — Landing Page Script
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── Scroll-triggered fade-in animations ── */
  const fadeTargets = document.querySelectorAll(
    '.reason-card, .review-card, .pack-card, .stat-item, ' +
    '.reassurance-item, .ingredient-item, .intro-text, ' +
    '.product-intro-inner, .product-section-inner, .transition-quote p'
  );

  fadeTargets.forEach(el => el.classList.add('fade-in'));

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  fadeTargets.forEach(el => observer.observe(el));

  /* ── Sticky header shadow on scroll ── */
  const header = document.querySelector('.site-header');
  window.addEventListener('scroll', () => {
    if (window.scrollY > 60) {
      header.style.boxShadow = '0 4px 24px rgba(0,0,0,0.12)';
    } else {
      header.style.boxShadow = '0 2px 12px rgba(0,0,0,0.05)';
    }
  });

  /* ── Smooth anchor scrolling ── */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const headerH = document.querySelector('.site-header').offsetHeight;
        const top = target.getBoundingClientRect().top + window.scrollY - headerH - 16;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  /* ── Pack card hover pulse for featured ── */
  const featuredPacks = document.querySelectorAll('.pack-card--featured');
  featuredPacks.forEach(card => {
    card.addEventListener('mouseenter', () => {
      card.style.boxShadow = '0 20px 60px rgba(212,169,106,0.35)';
    });
    card.addEventListener('mouseleave', () => {
      card.style.boxShadow = '0 12px 48px rgba(0,0,0,0.22)';
    });
  });

  /* ── Countdown urgency timer (optional cosmetic element) ── */
  function updateTimer() {
    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(23, 59, 59, 0);
    const diff = midnight - now;
    const h = Math.floor(diff / 3600000).toString().padStart(2, '0');
    const m = Math.floor((diff % 3600000) / 60000).toString().padStart(2, '0');
    const s = Math.floor((diff % 60000) / 1000).toString().padStart(2, '0');
    document.querySelectorAll('.timer-display').forEach(el => {
      el.textContent = `${h}:${m}:${s}`;
    });
  }

  if (document.querySelector('.timer-display')) {
    updateTimer();
    setInterval(updateTimer, 1000);
  }

});
